/* ═══════════════════════════════════════════════════════════════════════════
   GRAVV — Pure utility functions
   No React, no T, no Supabase deps — safe to import anywhere
═══════════════════════════════════════════════════════════════════════════ */

export const fmtDate = (d, opts = { day: "2-digit", month: "short" }) =>
  new Date(d).toLocaleDateString("fr-FR", opts);

export const daysUntil = (d) => Math.ceil((new Date(d) - new Date()) / 86400000);

// Parse "YYYY-MM-DD" as LOCAL midnight (not UTC) to avoid timezone shifts
export const parseLocalDate = (s) => {
  if (!s) return new Date(NaN);
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const allureFromPace = (distKm, dureeMin) =>
  distKm > 0
    ? `${Math.floor(dureeMin / distKm)}:${String(Math.round((dureeMin / distKm % 1) * 60)).padStart(2, "0")}`
    : "--:--";

export const timeToSec = (s) => {
  const p = s.replace("h", ":").split(":").map(Number);
  return p.length === 3 ? p[0] * 3600 + p[1] * 60 + p[2]
       : p.length === 2 ? p[0] * 60 + p[1]
       : 0;
};

export const riegelPredict = (kd, kts, td) => {
  const t = kts * Math.pow(td / kd, 1.06);
  const h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), s = Math.round(t % 60);
  return h > 0 ? `${h}h${String(m).padStart(2, "0")}` : `${m}:${String(s).padStart(2, "0")}`;
};

export const secToHMS = (s) => {
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), ss = Math.round(s % 60);
  return h > 0
    ? `${h}h${String(m).padStart(2, "00")}:${String(ss).padStart(2, "00")}`
    : `${m}:${String(ss).padStart(2, "00")}`;
};

export const paceFmt = (secPerKm) => {
  const m = Math.floor(secPerKm / 60), s = Math.round(secPerKm % 60);
  return `${m}:${String(s).padStart(2, "0")}`;
};
